module.exports = __webpack_public_path__ + "static/media/15.c2320951.png";